import {DISTRIBUTION_CONSTANTS, NODE_LICENSES} from '../../../constants/distribution.constants';
import Model from '../Model';

export default class ArtifactoryLicenseModel extends Model {
	constructor(data) {
		super(data);
		this.license_status = _.find(DISTRIBUTION_CONSTANTS.EDGE_NODE_LICENSES.STATUSES, status => status.name === data.license_status) || null;
		this.license_type = _.find(DISTRIBUTION_CONSTANTS.EDGE_NODE_LICENSES.TYPES, type => type.name === data.license_type) || null;
		this.valid_license = (this.license_status === null && this.license_type === null) ||
			(this.license_status && this.license_status.name === NODE_LICENSES.VALID && this.license_type.couldBeEdgeNode);
		this.license_status_message = this._getLicenseStatusMessage();
	}

	_getLicenseStatusMessage() {
		//if(this.license_status === null) return NODE_LICENSES.VALID;
		if(!this.license_status) return NODE_LICENSES.NO_LICENSE;
		if(this.license_status.name !== NODE_LICENSES.VALID) return this.license_status.label;
		if(!this.license_type.couldBeEdgeNode) return this.license_type.label;
		return '';
	}

	build() {
		return this;
	}
}



// WEBPACK FOOTER //
// ./modules/distribution/core/models/distribution/ArtifactoryLicenseModel.js